import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import EvenScheduleHeader from "./EvenScheduleHeader";

// ✅ Composant pour chaque élément de la timeline
const EventItem = ({ event }) => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: -50 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.5 }}
      className="mb-6 ml-6 relative"
    >
      <div className="absolute -left-[2.3rem] w-6 h-6 bg-[#003f97] rounded-full border-4 border-white"></div>
      <div className="bg-[#003f97] text-white py-2 px-4 rounded-lg inline-block font-semibold">
        {event.time}
      </div>
      <h3 className="text-lg font-bold mt-2">{event.title}</h3>
    </motion.div>
  );
};

const EventSchedule = ({ date, sect, partImg, events, partners, desc }) => {
  return (
    <div>
      <EvenScheduleHeader date={date} sect={sect} desc={desc} />
      <section className=" lg:container grid grid-cols-1 lg:grid-cols-2 gap-10">
        <div className="p-8">
          <img src={partImg} alt="Partenariat" className="rounded-lg " />
          <div className="mt-6">
            <h3 className="text-lg font-semibold">En partenariat avec</h3>
            <div className="flex flex-wrap items-center gap-10 mt-4">
              {partners?.with?.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Logo 1"
                  className=" h-16 lg:h-24"
                />
              ))}
            </div>
          </div>
          <div className="mt-6">
            <h3 className="text-lg font-semibold">Et participation de</h3>
            <div className="flex flex-wrap items-center gap-6 mt-4">
              {partners?.participation?.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt="Logo 1"
                  className=" h-16 lg:h-24"
                />
              ))}
            </div>
          </div>
        </div>

        <div>
          <div className=" lg:hidden p-8 bg-gray-100 ">
            <div className="space-y-4 ">
              <h2 className="text-4xl lg:text-6xl font-bold text-navy-900">
                Programme de la conférence
              </h2>
              <div className="space-y-2">
                <h3 className="text-2xl font-semibold text-indigo-600">
                  {sect}
                </h3>
                <p className="text-gray-700 font-medium">{date}</p>
              </div>
            </div>
          </div>
          <div className="max-w-4xl mx-auto p-6">
            <div className="relative border-dashed border-l-2 border-[#00075e]">
              {events &&
                events.map((event, index) => (
                  <EventItem key={index} event={event} />
                ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EventSchedule;
